export const config = {
    api: {
        USER_SERVICE_URL: process.env.REACT_APP_USER_SERVICE_URL,
    },
    reactAppVersion: process.env.REACT_APP_VERSION,
};
